<template lang="pug">
  .alert-box(:class="type")
    p {{ textFormatted }}
</template>

<script>

export default {
  name: 'AlertBox',
  components: {
  },
  props: {
    text: [String, Object],
    type: String
  },
  data () {
    return {
    }
  },
  computed: {
    textFormatted () {
      let text = this.text
      if (typeof this.text === 'object') {
        text = Object.keys(this.text).map(key => {
          return text[key]
        })
        text = text.join('\n')
      }
      return text
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="stylus">
  .alert-box
    border-radius $border-radius
    margin-bottom $spacing-3
    padding $spacing-3
    p
      margin-bottom 0
    &.info
      border 1px solid $background-info
      color $background-info
    &.danger
      border 1px solid #ff794f
      color #ff794f
</style>
